import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faXmark, faPlus, faUsers } from '@fortawesome/free-solid-svg-icons';

const initialsOf = (name) => {
    const words = (name || '').trim().split(/\s+/).filter(Boolean);
    if (words.length === 0) return '?';
    return words.map((w) => w[0]).join('').slice(0, 2).toUpperCase();
};

// Inset panel rendered below an artist row: member list + footer actions.
// Mirrors the iOS members panel. Member names resolve through `profiles`
// (uid -> display string), loaded lazily by the parent.
const ArtistMembersPanel = ({
    memberUids,
    profiles,
    currentUid,
    busy,
    pendingCount,
    onRemoveMember,
    onInvite,
    onManageLinks,
}) => {
    return (
        <div className="artist-members-panel">
            {memberUids === undefined ? (
                <div className="artist-member-row">
                    <div className="skeleton-avatar" />
                    <div className="skeleton-line" style={{ width: '40%' }} />
                </div>
            ) : memberUids.length === 0 ? (
                <div className="artist-empty">No members.</div>
            ) : (
                memberUids.map((uid) => {
                    const isSelf = uid === currentUid;
                    const resolved = profiles[uid];
                    const name = resolved || (resolved === undefined ? null : `Member ${uid.slice(0, 6)}`);
                    return (
                        <div key={uid} className="artist-member-row">
                            <div className="artist-row-avatar small">
                                {resolved ? initialsOf(resolved) : <FontAwesomeIcon icon={faUser} />}
                            </div>
                            {name ? (
                                <span className="artist-member-name">{name}</span>
                            ) : (
                                <span className="skeleton-line" style={{ width: '45%' }} />
                            )}
                            {isSelf && <span className="artist-member-you">YOU</span>}
                            {!isSelf && (
                                <button
                                    type="button"
                                    className="artist-member-remove"
                                    disabled={busy}
                                    title="Remove member"
                                    aria-label="Remove member"
                                    onClick={() => onRemoveMember(uid)}
                                >
                                    <FontAwesomeIcon icon={faXmark} />
                                </button>
                            )}
                        </div>
                    );
                })
            )}

            <button
                type="button"
                className="artist-panel-footer-row"
                disabled={busy}
                onClick={onInvite}
            >
                <span className="artist-panel-footer-icon is-dashed">
                    <FontAwesomeIcon icon={faPlus} />
                </span>
                <span>Invite member</span>
            </button>
            <button
                type="button"
                className="artist-panel-footer-row"
                disabled={busy}
                onClick={onManageLinks}
            >
                <span className="artist-panel-footer-icon">
                    <FontAwesomeIcon icon={faUsers} />
                </span>
                <span>Manage links &amp; requests</span>
                {pendingCount > 0 && (
                    <span className="artist-members-btn-count">{pendingCount}</span>
                )}
            </button>
        </div>
    );
};

export default ArtistMembersPanel;
